import Vue from 'vue'
import {mapActions,mapGetters} from 'vuex'

import AppLogos from 'js/components/layout-footer/_app-logos.js'
import ContactMixin from 'js/mixins/contact-modal-mixin'
import AddressInfo from 'js/components/address-info/index.js'
import PhoneNumber from 'js/components/phone-number/index.js'
import ComplaintsBook from 'js/components/complaints-book/index.js'
import ComplaintsBook2 from 'js/components/complaints-book2/index.js'
import FollowUs from 'js/components/follow-us/index.js'

import template from './index.pug'

Vue.component('layout-footer', {
  name: 'layout-footer-custom-vl',
  template: template(),

  components: {
    AppLogos,
    AddressInfo,
    PhoneNumber,
    ComplaintsBook,
    FollowUs,
    ComplaintsBook2
  },

  mixins: [ContactMixin],

  data() {
    return {}
  },
  computed: {
    ...mapGetters(["contraste"]),
  },
  methods: {
    ...mapActions(['openLanguageModal','escucharAudio']),

    goToTransportRequest() {
      this.$router.push({name: 'transport-request'})
    },

    goToGeneralConditionsOfTransport() {
      const routeData = this.$router.resolve({
        name: 'general-conditions-of-transport'
      })
      window.open(routeData.href)
    },

    goToCookiesPolicyText() {
      const routeData = this.$router.resolve({
        name: 'cookies-policy-text'
      })
      window.open(routeData.href)
    },

    goVamusExperiences() {
      try {
        const language = navigator.language
        if (language == null) {
          window.open('https://vamusalgarve.activbookings.com/en')
        } else if (language.includes('es')) {
          window.open('https://vamusalgarve.activbookings.com/es')
        } else if (language.includes('pt')) {
          window.open('https://vamusalgarve.activbookings.com/pt')
        } else {
          window.open('https://vamusalgarve.activbookings.com/en')
        }
      } catch (err) {
        window.open('https://vamusalgarve.activbookings.com/en')
      }
    },
    /**
       * @method safePush
       * Unified private method for robust routing, suppressing Vue Router's NavigationDuplicated errors.
       * @param {string} routeName - The name of the route to which you want to navigate.
       */
    _safePush(routeName) {
      if (!routeName || typeof routeName !== 'string') {
        console.error('Error de navegación: Navigation error: The route name is not valid.', routeName);
        return;
      }

      try {
        this.$router.push({ name: routeName })
          .catch(error => {
            if (error.name === 'NavigationDuplicated') {
              console.info(`Duplicate route silenced: ${routeName}`);
              return;
            }
            console.error(`Error attempting to navigate to ${routeName}:`, error);
          });
      } catch (e) {
        console.error(`Critical error when attempting to navigate to ${routeName}:`, e);
      }
    },

    goToAccessibilityStatement() {
      this._safePush('accessibility-statement');
    },

    goInstitutionalInformation() {
      this._safePush('institutional-information');
    },

    goToPrivacyPolicy() {
      this._safePush('privacy-policy');
    }

  }
})
